module.exports = __webpack_public_path__ + "static/media/logs.f789b387.svg";